import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d64f0gibdoed7v0v95bg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        alert('Thank you for subscribing!');
        form.reset();
      } else {
        alert('Subscription failed. Please try again.');
      }
    } catch (error) {
      alert('An error occurred. Please try again.');
    }
  };

  return (
    <footer className="bg-[#2C2C2C] text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="flex items-start justify-between mb-12">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/b5ab5398-94e8-4346-92ad-4861c4ee2246.png" 
              alt="Hudson Valley Trails" 
              className="h-10 w-auto"
            />
          </div>
          <p className="text-gray-400 text-sm">Your gateway to outdoor freedom</p>
        </div>

        <div className="grid grid-cols-4 gap-12 mb-16">
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Explore</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">Home</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">About</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white transition-colors text-sm">Blog</Link></li>
              <li><Link to="/destinations" className="text-gray-400 hover:text-white transition-colors text-sm">Destinations</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Resources</h3>
            <ul className="space-y-3">
              <li><Link to="/tips-guides" className="text-gray-400 hover:text-white transition-colors text-sm">Tips & Guides</Link></li>
              <li><a href="#reviews" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Campground Reviews</a></li>
              <li><a href="#rentals" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">RV Rentals</a></li>
              <li><a href="#gear" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Gear Shop</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Connect</h3>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">Contact</Link></li>
              <li><a href="#newsletter" className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer">Newsletter</a></li>
              <li><a href="https://instagram.com" target="_blank" rel="nofollow" className="text-gray-400 hover:text-white transition-colors text-sm">Instagram</a></li>
              <li><a href="https://facebook.com" target="_blank" rel="nofollow" className="text-gray-400 hover:text-white transition-colors text-sm">Facebook</a></li>
            </ul>
          </div>

          <div className="text-right">
            <p className="font-serif text-white mb-2">© {currentYear} Hudson Valley Trails</p>
            <p className="text-gray-400 text-sm mb-4">All rights reserved</p>
            <div className="flex gap-4 justify-end">
              <a href="https://instagram.com" target="_blank" rel="nofollow" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="nofollow" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="nofollow" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="nofollow" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-youtube-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between pt-8 border-t border-gray-700">
          <div className="w-48 h-32 rounded-lg overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/d8d3973a6a85cb52797e5ff0dd6d36dd.jpg" 
              alt="Cozy RV Interior" 
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1 px-12">
            <p className="font-serif text-3xl text-white leading-tight">
              Start planning<br />
              your next<br />
              escape
            </p>
          </div>

          <div className="w-96">
            <p className="text-gray-400 text-sm mb-2">Join 5,000+ outdoor enthusiasts</p>
            <p className="text-gray-400 text-sm mb-4">Get insider tips delivered weekly</p>
            <form className="flex gap-2" data-readdy-form id="footer-newsletter" onSubmit={handleSubmit}>
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                className="flex-1 px-4 py-2.5 bg-transparent border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-forest text-sm"
                required
              />
              <button
                type="submit"
                className="px-6 py-2.5 bg-forest text-white rounded-lg hover:bg-forest-light transition-colors flex items-center gap-2 whitespace-nowrap"
              >
                Subscribe
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-700 text-center">
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="nofollow" 
            className="text-gray-500 hover:text-gray-400 text-xs transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;